const goBackBtn = document.getElementById("goBackBtn");
const goBackBtnWomens = document.getElementById("goBackBtn-womens");
const goBackBtnMens = document.getElementById("goBackBtn-mens");
const mensEl = document.getElementById("mens");
const womensEl = document.getElementById("womens");
const hideOnOpen = document.querySelectorAll(".hide-on-open");

if(goBackBtn) {
    goBackBtn.addEventListener('click', ()=>{
        const openedDetails = document.querySelectorAll('details[open]');
        if(openedDetails){
            openedDetails[openedDetails.length - 1].removeAttribute("open");
            if(openedDetails.length == 2) {
                showCollectionImage();
            }
        }
    })
}

if(goBackBtnWomens) {
    goBackBtnWomens.addEventListener('click', ()=>{
        const openedDetails = goBackBtnWomens.parentElement.parentElement.querySelectorAll('details[open]');
        if(openedDetails){
            openedDetails[openedDetails.length - 1].removeAttribute("open");
            if(openedDetails.length == 2) {
                showCollectionImage();
            }
        }
    })
}

if(goBackBtnMens) {
    goBackBtnMens.addEventListener('click', ()=>{
        const openedDetails = goBackBtnMens.parentElement.parentElement.querySelectorAll('details[open]');
        if(openedDetails){
            openedDetails[openedDetails.length - 1].removeAttribute("open");
            if(openedDetails.length == 2) {
                showCollectionImage();
            }
        }
    })
}

if(mensEl) {
    mensEl.addEventListener('click', ()=>{
        localStorage.setItem('gndr', 'm');
    })
}

if(womensEl) {
    womensEl.addEventListener('click', ()=>{
        localStorage.setItem('gndr', 'w');
    })
}

if(hideOnOpen) {
    hideOnOpen.forEach((element) => {
        element.addEventListener('click', hideCollectionImages);
    });
}

function hideCollectionImages() {
    hideOnOpen.forEach((element) => {
        element.classList.add('hidden');
    });
}

function showCollectionImage() {
    hideOnOpen.forEach((element) => {
        element.classList.remove('hidden');
    });
}